import React, { useState, useEffect, Fragment } from 'react';

import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { API_Orders_Voucher } from '../../../../../../constants/APIs';
import {
    DropdownMenu,ModalHeader,Modal,ModalBody,ModalFooter,
    DropdownItem, UncontrolledDropdown,Label,FormGroup,
    DropdownToggle, Button, Row, Input, Card
} from 'reactstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import ReactTable from 'react-table';
import DataTablePagination from '../../../../../../components/DatatablePagination';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { uuid } from 'short-uuid';
import ConfirmModal from './forms/ConfirmModal';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import Validation from '../../../../../../components/Validation';
const VoucherPayment = ({ loading, voucherList, showRedeem, handleBack, dropDown, voucherFilter, handleVoucherFilter,
    voucherId, handleRedeemVoucher, handleDropDown, handleCreateVoucherButtonShow, handleVoucherPaymentsById, onstartDateChange, onEndDateChange, handleSubmit, orderList, handleSearchfilter }) => {
    const [isLoading, setIsLoading] = useState(loading);
    const [searchVocuher, setSearchVoucher] = useState([]);
    const [open,setOpen] = useState(false);
    const [msg,setMsg] =useState([]);
    const [startDate, setStartDate] = useState(moment().subtract(15, 'days'));
    const [endDate, setEndDate] = useState(moment());
    const [confirmModal, setShowConfirmModal] = useState(false);
    const [resendEmail, setResendEmail] = useState(false);
    const [voidModal, setVoidModal] = useState(false);
    const [voucherData, setVoucherData] = useState("");
    const [voucherNumber, setVoucherNumber] = useState("");
    const [voidReason, setVoidReason] = useState("");
    const [emailData,setEmailData]=useState([]);
    const dataTableColumns = [
        {
            Header: 'Payment Id',
            accessor: 'paymentid',
            Cell: props => <p style={{ marginLeft: "19%" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset', "width": "100px" }
        },
        {
            Header: 'Voucher',
            accessor: 'name',
            Cell: props => <p style={{ marginLeft: "15%", width: "150px" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Voucher#',
            accessor: 'voucherNumber',
            Cell: props => <p style={{ marginLeft: "15%", width: "120px" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Order#',
            accessor: 'orderNumber',
            Cell: props => <p style={{ marginLeft: "11%", "width": "120px" }}>{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Status',
            accessor: 'status',
            Cell: props => <p style={{ marginLeft: "19%" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset', "width": "100px" }
        },
        {
            Header: 'Retail Price',
            accessor: 'price',
            Cell: props => <p style={{ marginLeft: "19%" }} >{props.row._original.currency.toUpperCase()} {props.value} </p>,
            style: { 'whiteSpace': 'unset', "width": "100px" }
        },
        {
            Header: 'Chosen Option',
            accessor: 'optionName',
            Cell: props => <p style={{ marginLeft: "19%", width: "150px" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Discount',
            accessor: 'discount',
            Cell: props => <p style={{ marginLeft: "19%" }} >{props.value}%</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Discounted Price',
            accessor: 'discountedPrice',
            Cell: props => <p style={{ marginLeft: "19%", "width": "120px" }} >{props.row._original.currency.toUpperCase()} {props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Fee',
            accessor: 'processingFee',
            Cell: props => <p style={{ marginLeft: "19%", "width": "150px" }}>$ {(parseFloat(props.row._original.processingFee))}</p>,
            style: { 'whiteSpace': 'unset' }
        }
        , {
            Header: 'Gifted',
            accessor: 'gifted',
            Cell: props => <p style={{ marginLeft: "19%" }} >{props.row._original.gifted ? "Yes" : "No"}</p>,
            style: { 'whiteSpace': 'unset', }
        },
        {
            Header: '',
            accessor: 'redeem',
            Cell: props =><Fragment>            
                {props.value ==="2" ?<div>
                    <UncontrolledDropdown className="w-15 text-center w-sm-100" style={{position: 'absolute',right: '-1.5rem'}} >
                    <DropdownToggle caret color="outline-dark" size="xs">
                      more
                    </DropdownToggle>
                    <DropdownMenu>
                    <DropdownItem
                        key='View'
                        onClick={() => handleClick(props.row._original)}
                      >
                        Redeem voucher
                      </DropdownItem>   
                      <DropdownItem
                        key='View'
                        onClick={() => handleVoid(props.row._original)}
                      >
                        Void voucher
                      </DropdownItem>
                      <DropdownItem
                        key='View'
                       // onClick={() => { handleViewDetails(item.invitationId, item.connectionId, item.approvalStatus); setId(item.id); setIsShow(!isShow); }}
                      >
                        Refund voucher 
                      </DropdownItem>

                      <DropdownItem
                        key='View'
                       onClick={() => { showResendEmail(props.row._original) }}
                      >
                        Resend email
                      </DropdownItem>                
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>:null}</Fragment>,
            style: { 'whiteSpace': 'unset' }
        }    
    ];
    const addEmailData=()=>{
       let data =[...emailData];
       data.push({
        id:uuid(),
        email:'',
            disable:false
       });
       setEmailData(data);
    }

    const showResendEmail=(data)=>{
        setResendEmail(true);
        setVoucherNumber(data.voucherNumber);
        let email=[...emailData];
        if (data.gifted === false) {           
            email.push({
                id: uuid(),
                email: data.email,
                disable: true
            });
        }
        setEmailData(email);
    };
    const handleResendEmail = () => {
        AxiosAPI({
            method: 'put',
            url: `${API_Orders_Voucher}/voucher/resend`,
            data:{'VoucherNumber':voucherNumber,'Email':emailData.map((f)=>f.email)}
        })
            .then((res) => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                setEmailData([]);
                setResendEmail(false);
                NotificationManager.success(
                    '',
                    'Email sent successfully.',
                    3000,
                    null,
                    null,
                    'success'
                  );
                }
            })
    };    
 
    const handleClick = (data) => {        
        setSearchVoucher("");
        setShowConfirmModal(true);
        setVoucherData(data);

    };
    const handleVoid = (data) => {
        setSearchVoucher("");
        setVoidModal(true);
        setVoucherData(data);
        setVoucherNumber(data.voucherNumber);

    };
    const handleChangeDate = date => {
        setStartDate(date);
        onstartDateChange(date);
    };
    const handleChangeEndDate = date => {
        setEndDate(date);
        onEndDateChange(date);
    };
    
    const deleteEmail=(id)=>{
     let email=emailData.filter((f)=>f.id!==id);
     setEmailData(email);
    };
    const handleChange = (index, e) => {
        e.persist();
        const newItems = [...emailData];
        newItems[index]['email'] = e.target.value;
        setVoucherData(newItems);    
    };
    const orderVoucher = () => {
        
          
          AxiosAPI({
            method: 'put',
            url: `${API_Orders_Voucher}/voucher/void`,
            data:{'VoucherNumber':voucherNumber,'Reason':voidReason}
          })
            .then(res => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                setVoidModal(false);
                }
              
            })
            .catch(err => null);        
        
      };

    return (
        <Fragment>
            <Row className="col-md-12">
                <Colxx xxs="10" md="2" className="">
                    <a onClick={() => { handleBack(); handleCreateVoucherButtonShow(); }}>
                        <h1 class="iconsminds-back"></h1></a>
                </Colxx>
            </Row>
            <Row className="col-md-12">
                <Colxx xxs="2" md="2" className="mb-2">
                    <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                        <DropdownToggle caret color="outline-dark" size="xs">
                            {dropDown.filter(f=>f!==undefined)[0]}
                        </DropdownToggle>
                        <DropdownMenu>
                            {voucherList.length > 0 && (
                                voucherList.map((e) => {
                                    if(e.approvalStatus !== '1')
                                    {
                                    return (
                                        <Fragment>
                                            <DropdownItem
                                                key={e.id}
                                                value={e.id}                                                
                                                onClick={(f) => {                                               
                                                    handleDropDown(e.name);
                                                    handleVoucherPaymentsById(e.id);
                                                }}
                                            >        {e.name}
                                            </DropdownItem>
                                        </Fragment>
                                    );
                                            }
                                }))}
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </Colxx>
            </Row>
            <Row className="col-md-12">
                <Colxx xxs="2" md="2" className="mb-2">
                    <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                        {voucherList !== undefined && voucherList.length > 0 && (<DropdownToggle caret color="outline-dark" size="xs">
                            {voucherFilter}
                        </DropdownToggle>)}
                        <DropdownMenu>
                            <DropdownItem
                                key="All"
                                value="All"
                                onClick={(f) => {
                                    handleVoucherFilter('All');
                                    handleVoucherPaymentsById(voucherId, 'All');
                                }}
                            >      All
                            </DropdownItem>

                            <DropdownItem
                                key="Active"
                                value="Active"
                                onClick={(f) => {
                                    handleVoucherFilter('Active');
                                    handleVoucherPaymentsById(voucherId, 2);
                                }}
                            >      Active
                            </DropdownItem>
                            <DropdownItem
                                key="Redeemed"
                                value="Redeemed"
                                onClick={(f) => {
                                    handleVoucherFilter('Redeemed');
                                    handleVoucherPaymentsById(voucherId, 0);
                                }}
                            >      Redeemed
                            </DropdownItem>
                            <DropdownItem
                                key="Void"
                                value="Void"
                                onClick={(f) => {
                                    handleVoucherFilter('Void');
                                    handleVoucherPaymentsById(voucherId, 1);
                                }}
                            >      Void
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </Colxx>
            </Row>
            <Row className="col-md-12">
                <Colxx xxs="10" md="2" className="mb-2">
                    <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                        <Input value={searchVocuher} className="form-control" placeholder="Search" onChange={(e) => {
                            setSearchVoucher(e.target.value);
                            handleSearchfilter(e.target.value);
                        }}></Input>
                    </div>
                </Colxx>
            </Row>
            <br />
            <Row className="col-md-12">

                <Fragment>

                    <Colxx xxs="12" md="2" className="mb-2">
                        <DatePicker
                            selected={startDate}
                            onChange={handleChangeDate}
                            placeholderText="Start Date"
                            dateFormat="DD/MM/YYYY"
                        />
                    </Colxx>
                    <Colxx xxs="12" md="2" className="mb-2">
                        <DatePicker
                            selected={endDate}
                            onChange={handleChangeEndDate}
                            placeholderText="End Date"
                            dateFormat="DD/MM/YYYY"
                        />
                    </Colxx>
                    <Colxx xxs="12" md="1" className="mb-2">
                        <Button
                            color="primary"
                            className="mb-2"
                            onClick={() => { setSearchVoucher(""); handleSubmit() }}
                        >
                            <IntlMessages id="forms.submit" />
                        </Button>
                    </Colxx>
                </Fragment>


            </Row >
            <Row className="col-md-12">
                <Colxx xxs="12">
                    <Card className="d-flex flex-row mb-3">
                        <Fragment>
                            <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                                {!isLoading && orderList ? (
                                    <ReactTable
                                        data={orderList}
                                        columns={dataTableColumns}
                                        defaultPageSize={10}
                                        filterable={false}
                                        showPageJump={true}
                                        PaginationComponent={DataTablePagination}
                                        showPageSizeOptions={true}
                                        className="-striped -highlight -bordered"

                                        style={{ width: "100%" }}
                                    />
                                ) : ""
                                }
                            </div>
                        </Fragment>
                    </Card>
                </Colxx>
            </Row>
            {confirmModal && <ConfirmModal
                showModal={confirmModal}
                message={"Are you sure you want to redeem the voucher ?"}
                title={"Redeem Confirmation"}
                buttonName={"Redeem"}
                hideModal={() => {
                    setShowConfirmModal(false);
                }}
                voucherdata={voucherData}
                redeemStatus={0}
                handleRedeemVoucher={handleRedeemVoucher}
            />}    
             
            <Modal
                isOpen={voidModal}
                toggle={() =>setVoidModal(false)}
                size="lg"
                style={{ maxWidth: '30%' }}
            >
                <ModalHeader toggle={() =>   setVoidModal(false)}><h3>Voucher</h3></ModalHeader>
                <ModalBody><div className="">
                    <Label>Reason</Label>
                    <Input type="text" value={voidReason} onChange={(e)=>setVoidReason(e.target.value)}>
                    </Input>
                    </div></ModalBody>
                <ModalFooter>                    
                    <Button color="primary" onClick={() => {orderVoucher(); }}>
                        Send
                    </Button>
                    <Button onClick={() => setVoidModal(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal > 
            <Modal
                isOpen={resendEmail}
                toggle={() => { setEmailData([]); setResendEmail(false)}}
                size="lg"
                style={{ maxWidth: '50%' }}
            >
                <ModalHeader toggle={() => { setEmailData([]); setResendEmail(false)}}><h3>Resend Email</h3></ModalHeader>
                <ModalBody>
                    <div className="">
                        <Row className="mb-2">
                            <Colxx sm={12}>
                                <h4>Email</h4>
                            </Colxx>
                            <Colxx sm={12}>
                                {emailData.map((m, index) => (
                                    <Row key={`${m}~${index}`}>
                                        <Colxx sm={8} className="md-3">
                                            <FormGroup>
                                                <Input type="text" disabled={m.disable} value={m.email} onChange={(e) => {                                                    
                                                          handleChange(index,e);
                                                }}/>
                                            </FormGroup>

                                        </Colxx>
                                        <Colxx sm={1} className="mb-3">                                            
                                            <div>
                                                <Button
                                                    onClick={() => deleteEmail(m.id)}
                                                    color="secondary"
                                                    size="xs"
                                                    outline
                                                    style={{ margin: '6px' }}
                                                >
                                                    X
                                                </Button>
                                            </div>
                                        </Colxx>
                                    </Row>
                                ))}
                            </Colxx>
                            <Colxx sm={12} className="md-3">
                                <Button
                                    onClick={addEmailData}
                                    color="primary"
                                    size="xs"
                                    outline
                                    style={{ margin: '6px' }}
                                >
                                    + Add email
                                </Button>
                            </Colxx>
                        </Row>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={() => { setEmailData([]); setResendEmail(false)}}>
                        Cancel
                    </Button>
                    <Button color="primary" onClick={() => { handleResendEmail(); }}>
                        Send
                    </Button>
                </ModalFooter>
            </Modal>   
            <Validation open={open} messages={msg} toggle={()=>{setOpen(!open)}}></Validation> 
        </Fragment >
    );
};

export default VoucherPayment;
